<template>
  <div class="detailBox clearfix">
    <div class="detailBox-l">
      <div class="title">
        <h1>{{ showMsg.planName }}</h1>
      </div>

      <!-- 基础信息部分 -->
      <div class="base">
        <h2>基础信息</h2>
        <ul>
          <li>
            <em>姓名：</em><span>{{ showMsg.studentName }}</span>
          </li>
          <li>
            <em>准考证号：</em><span>{{ showMsg.entranceNo }}</span>
          </li>
          <li>
            <em>证件号：</em><span>{{ showMsg.cardNo }}</span>
          </li>
          <li>
            <em>考试科目：</em><span>{{ showMsg.courseName }}</span>
          </li>
          <li>
            <em>分数：</em><span>{{ showMsg.score }}</span>
          </li>
          <li>
            <em>考试状态：</em><span>{{ showMsg.checkStateName }}</span>
          </li>
        </ul>
      </div>
      <div class="school">
        <h2>成绩申诉表</h2>
        <img
          :src="showMsg.applyFilePath"
          alt=""
          @click="lookImg(showMsg.applyFilePath)"
          class="widthimg"
        />
      </div>
    </div>
    <div class="right">
      <div class="rightMsg-r">
        <div class="showResult">
          <template>
            <h1>当前状态</h1>
            <div class="examine-state" v-if="showMsg.auditState == 0">
              <el-form>
                <div class="Approveds">待审核</div>
                <el-form-item>
                  <el-radio-group
                    v-model="ruleForm.allowReApply"
                    v-if="scoreEndTime == 1"
                  >
                    <button :label="0" @click="passthrough" class="passthrough">
                      通过
                    </button>
                    <button :label="1" @click="reject" class="nopassthrough">
                      驳回
                    </button>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
            <div v-if="showMsg.auditState == 2">
              <div class="Approved">审核通过</div>
              <div class="ApprovedData">
                <p>审核时间：</p>
                <p>{{ showMsg.auditDate }}</p>
              </div>
              <div class="ApprovedName">
                <p>审核人：</p>
                <p>{{ showMsg.auditUserRealName }}</p>
              </div>
            </div>
            <div v-if="showMsg.auditState == 1">
              <div class="noApproved">审核不通过</div>
              <div class="ApprovedData">
                <p>不通过原因：</p>
                <p>{{ showMsg.auditRemark }}</p>
              </div>
              <div class="ApprovedData">
                <p>是否允许重新申诉：</p>
                <p>{{ showMsgallowReApply }}</p>
              </div>
              <div class="ApprovedData">
                <p>审核时间：</p>
                <p>{{ showMsg.auditDate }}</p>
              </div>
              <div class="ApprovedData">
                <p>审核人：</p>
                <p>{{ showMsg.auditUserRealName }}</p>
              </div>
            </div>
            <div class="rightMsg">
              <span round class="nextPrevious" @click="nextPreviousone"
                >下一条</span
              >
            </div>
            <ots-custom-dialog
              :dialog.sync="applyMsgDialog"
              title="驳回成绩申诉"
            >
              <template v-slot:content>
                <div class="exportDialog">
                  <el-form ref="exportForm"  :rules="rules" :model="ruleForm">
                    <el-form-item label="驳回原因" prop="auditRemark">
                      <el-input
                        type="textarea"
                        v-model="ruleForm.auditRemark"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="重新提交申诉信息">
                      <el-radio-group v-model="ruleForm.allowReApply">
                        <el-radio-button :label="1">允许</el-radio-button>
                        <el-radio-button :label="2">不允许</el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </el-form>
                </div>
              </template>
              <template v-slot:footer>
                <el-button round @click="applyMsgDialog = false"
                  >取消</el-button
                >
                <el-button round type="primary" @click="rightAudit"
                  >确定</el-button
                >
              </template>
            </ots-custom-dialog>
            <div class="auditInfo">
              <div v-if="showMsg.primaryDate">
                <p class="col_grayQ">初审时间</p>
                <p>{{ showMsg.primaryDate }}</p>
              </div>
              <div v-if="showMsg.primaryUser">
                <span class="col_grayQ">初审人</span>
                <p>{{ showMsg.primaryUser }}</p>
              </div>
              <div v-if="showMsg.ultimateDate">
                <span class="col_grayQ">终审时间</span>
                <p>{{ showMsg.ultimateDate }}</p>
              </div>
              <div v-if="showMsg.ultimateUser">
                <span class="col_grayQ">终审人</span>
                <p>{{ showMsg.ultimateUser }}</p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  usergetScoreReview,
  passthroughState,
  ScoreReview,
  getSinglePlan,
} from "@/http/modules/examSet/examBatch";
export default {
  data() {
    return {
      studentCourseId:'',
      scoreEndTime: "",
      applyMsgDialog: false,
      isCanHandle: "",
      showMsgallowReApply: "",
      showMsg: "",
      ruleForm: {
        allowReApply: "2",
        auditState: "",
        auditRemark: "",
        id: "",
      },
      isCanHandleSecond: "",
      rules:{
        auditRemark: [
          { required: true, message: "请填写驳回原因", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.studentCourseId = this.$route.query.studentCourseId
    this.details();
    this.getPlanData();
  },
  watch: {
    "$route.query": {
      handler(val) {
        this.details(val);
      },
      deep: true,
    },
    showMsg: {
      handler() {},
      deep: true,
    },
  },
  methods: {
    lookImg(img) {
      this.lookBigImage(img);
    },
    details(val) {
      usergetScoreReview({
        planId: this.$route.query.planId,
        studentCourseId: this.studentCourseId,
      }).then((res) => {
        this.showMsg = res.data;
        this.ruleForm.id = res.data.id;
        if (this.showMsg.allowReApply == 1) {
          this.showMsgallowReApply = "允许";
        } else {
          this.showMsgallowReApply = "不允许";
        }
      });
    },
  
    getPlanData(planId) {
      getSinglePlan({ planId: this.$route.query.planId }).then(({ data }) => {
        let scoreReviewEndTime = new Date(data.scoreReviewEndTime).getTime();
        let Reviewitem = new Date().getTime();
        if (Reviewitem < scoreReviewEndTime) {
          this.scoreEndTime = 1;
        } else {
          this.scoreEndTime = 0;
        }
      });
    },
    reject() {
      this.applyMsgDialog = true;
    },
    rightAudit() {
      this.$refs['exportForm'].validate(async(valid)=>{
        if(valid){
          this.ruleForm.auditState = 1;
      passthroughState(this.ruleForm).then((res) => {
        this.applyMsgDialog = false;
        if (res.code == 1) {
          this.$event.$emit('scoreFuHeList')
          this.$message.success("驳回成功");
          this.details();
        }
      });
        }
      })
    },
    getNextId(studentCourseId) {
      ScoreReview({
        planId: this.$route.query.planId,
        studentCourseId,
      }).then((data) => {
        this.studentCourseId = data.data.studentCourseId
      })
    },
    nextPreviousone() {
      const { path } = this.$route;
      ScoreReview({
        planId: this.$route.query.planId,
        studentCourseId:this.$route.query.studentCourseId
      }).then((data) => {
        this.studentCourseId = data.data.studentCourseId
        usergetScoreReview({ planId: this.$route.query.planId, studentCourseId: this.studentCourseId}).then((res)=>{
          this.showMsg = res.data;
          this.ruleForm.id = res.data.id;
        })
      })
    },
    examine() {
      this.$api.applyAudit.examine(this.ruleForm).then((res) => {
        const { code, data } = res;
        console.log(res);
        if (code == 1) {
          this.applyMsgDialog = false;
          this.$message.success("操作成功");
          if (data) {
            for (let key in data) {
              this.showMsg[key] = data[key];
            }
          }
          this.resetForm();
        }
      });
      this.details(this.$route.query);
    },
    resetForm() {
      this.ruleForm = {
        planId: "",
        studentCourseId: "",
      };
    },
    passthrough() {
      passthroughState({
        allowReApply: "0",
        auditRemark: "",
        auditState: "2",
        id: this.ruleForm.id,
      }).then((res) => {
      this.$event.$emit('scoreFuHeList')
        this.$message.success("通过");
        this.details();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.extImg {
  width: 100%;
  display: flex !important;
  align-items: center;
}
.detailBox {
  position: relative;
  .detailBox-l {
    width: calc(100% - 264px);
    padding: 24px;
    background: #fff;
    border-radius: 8px;
    float: left;
    box-sizing: border-box;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 24px;
      border-bottom: 1px solid #f1f2f5;
      h1 {
        color: #2d2f33;
        font-size: 20px;
      }
    }
    .base {
      width: 75%;
      position: relative;
      h2 {
        border-top: none;
      }
      img.showMsgPhoto {
        position: absolute;
        right: -180px;
        top: 42px;
        width: 116px;
        height: 152px;
        margin-right: 58px;
      }
    }

    h2 {
      font-size: 16px;
      color: #2d2f33;
      padding: 32px 0;
      border-top: 1px solid #f1f2f5;
    }
    ul {
      li {
        display: inline-block;
        font-size: 14px;
        margin-bottom: 24px;
        em {
          color: #9299a6;
          display: inline-block;
          vertical-align: middle;
          width: 96px;
          text-align: right;
          font-style: normal;
        }
        span {
          display: inline-block;
          vertical-align: middle;
          width: 204px;
        }
      }
      li:last-child {
        margin-bottom: 32px;
      }
    }
    .applyMsg li {
      display: block !important;
    }
  }
  .right {
    float: right;
    .rightMsg-r {
      background: #fff;
      width: 240px;
      border-radius: 8px;
      padding: 24px;
      box-sizing: border-box;

      .showResult {
        box-sizing: border-box;
        background: #fff;
        text-align: center;
        .showResult-t {
          display: flex;
          flex-direction: column;
          align-items: center;
          h1 {
            color: #2d2f33;
            font-size: 20px;
          }
          img {
            margin: 24px 0 12px 0;
          }
          p {
            font-size: 14px;
            color: #fe5958;
            margin-bottom: 24px;
          }
        }
        .showResult-b {
          text-align: left;
          padding-top: 16px;
          border-top: 1px solid #f1f2f5;
          span {
            font-size: 14px;
            color: #9299a6;
          }
          p {
            font-size: 14px;
            color: #45494d;
            margin-top: 8px;
          }
          .cause {
            margin-bottom: 32px;
          }
        }
      }
      .showResult {
        position: relative;
        text-align: left;
        padding-bottom: 2px;
        h1 {
          margin-bottom: 32px;
          text-align: left;
        }
        /deep/ .el-radio-button__inner {
          margin-right: 16px;
          color: #45494d !important;
          background: #f4f5f8 !important;
          font-size: 13px;
          border-radius: 4px !important;
          border: 1px solid #dadde6 !important;
          width: 64px;
          height: 32px;
          line-height: 32px;
          padding: 0;
        }
        /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          background: #ebf5ff !important;
          border: 1px solid #006aff !important;
          color: #006aff !important;
          box-shadow: none;
        }
        /deep/ .el-form-item__label {
          display: block;
          line-height: 1;
          padding-bottom: 16px;
          width: 100%;
          text-align: left;
        }

        /deep/ .el-button.is-round {
          padding: 10px 23px;
        }
      }
      .rightMsg {
        position: relative;
        left: -24px;
        bottom: -60px;
        width: 240px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        box-shadow: 0px -8px 12px 0px rgba(0, 0, 0, 0.05);
        border-radius: 0px 0px 8px 8px;
        background: #fff;
      }
    }
    .auditInfo {
      padding-left: 5px;
      margin-top: 40px;
      padding-top: 10px;
      & > div {
        margin-top: 8px;
      }
    }
  }
}
.examine-state {
  margin-top: 32px;
}
.Previous {
  display: inline-block;
  width: 80px;
  cursor: pointer;
  color: #006aff;
}
.nextPrevious {
  display: inline-block;
  cursor: pointer;
  width: 80px;
  color: #006aff;
}
.Approved {
  width: 100%;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1dbf60;
  line-height: 28px;
  text-align: center;
}
.ApprovedData {
  width: 100%;
  height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9299a6;
  line-height: 20px;
  margin-top: 30px;
}
.ApprovedName {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9299a6;
}
.noApproved {
  width: 100%;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: red;
  line-height: 28px;
  text-align: center;
}
.passthrough {
  width: 88px;
  height: 32px;
  background: #1dbf60;
  border-radius: 4px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  border: none;
}
.nopassthrough {
  width: 88px;
  height: 32px;
  background: red;
  border-radius: 4px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  border: none;
  margin-left: 10px;
}

.widthimg {
  border: none;
  margin-left: 30%;
  width: 300px;
  height: 400px;
}
.Approveds {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: 28px;
  text-align: center;
  color: #f27900;
}
</style>